export default {"src":"/_next/static/media/see-no-evil-own.31bb3167.svg","height":100,"width":100};